import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";

function DropdownMenu() {
  const [expandedCategory, setExpandedCategory] = useState([]); // Inicializa sem nenhuma categoria expandida
  const location = useLocation();

  const categorias = [
    {
      titulo: "INTEGRAÇÕES",
      links: [
        { href: "/integracoes" },
        {
          href: "/como-conectar-minha-conta-do-facebook-ou-instagram",
          texto: "Como conectar minha conta do Facebook ou Instagram?",
        },
        {
          href: "/solucao-de-problemas-conta-de-anuncio",
          texto: "Solução de problemas - Conta de Anúncio",
        },
        {
          href: "/solucao-de-problemas-publicos-personalizados-do-facebook",
          texto: "Solução de problemas - Públicos personalizados do Facebook",
        },
      ],
    },

    {
      titulo: "DATA ANALYTICS",
      links: [
        { href: "/data-analytics" },
        {
          href: "/como-acessar-a-analise-descritiva-da-minha-base",
          texto: "Como acessar a análise descritiva da minha base?",
        },
        {
          href: "/como-conhecer-meu-cliente",
          texto: "Como conhecer meu cliente?",
        },
        {
          href: "/analise-geografica",
          texto: "Análise Geográfica",
        },
        {
          href: "/jornada-do-cliente",
          texto: "Jornada do Cliente",
        },
        {
          href: "/entendendo-o-rfv-recencia-frequencia-e-valor",
          texto: "Entendendo o RFV: Recência, Frequência e Valor",
        },
      ],
    },

    {
      titulo: "DATA INTELLIGENCE",
      links: [
        { href: "/dataintelligence" },
        {
          href: "/o-que-e-enriquecimento-de-dados",
          texto: "O que é enriquecimento de dados?",
        },
        {
          href: "/como-enriquecer-meus-dados",
          texto: "Como enriquecer meus dados?",
        },
        {
          href: "/solucao-de-problemas-enriquecimento-com-erro-ou-pendencias",
          texto: "Solução de problemas - Enriquecimento com erro ou pendências",
        },
      ],
    },

    {
      titulo: "GEOMARKETING",
      links: [
        { href: "/geomarketing" },
        {
          href: "/o-que-e-um-publico-potencial",
          texto: "O que é um Público Potencial?",
        },
        {
          href: "/como-criar-um-publico-potencial",
          texto: "Como criar um público potencial?",
        },
        {
          href: "/por-que-escolher-uma-regiao-geografica",
          texto: "Por que escolher uma região geográfica?",
        },
      ],
    },

    {
      titulo: "MINHA CONTA E LOGIN",
      links: [
        { href: "/minha-conta-e-login" },
        {
          href: "/como-realizar-meu-primeiro-acesso",
          texto: "Como realizar meu primeiro acesso?",
        },
        {
          href: "/como-fazer-login",
          texto: "Como fazer login?",
        },
        {
          href: "/esqueci-minha-senha-o-que-fazer",
          texto: "Esqueci minha senha, o que fazer?",
        },
      ],
    },

    {
      titulo: "PERSONAS PSICOGRÁFICAS",
      links: [
        { href: "/personaspsicograficas" },
        {
          href: "/o-que-sao-as-informacoes-psicograficas-da-sales-box",
          texto: "O que são as informações psicográficas da Sales Box?",
        },
      ],
    },

    {
      titulo: "SMART SEGMENTATION",
      links: [
        { href: "/smartsegmentation" },
        {
          href: "/o-que-e-a-segmentacao-de-clientes",
          texto: "O que é a Segmentação de Clientes?",
        },
        {
          href: "/como-criar-uma-segmentacao-de-clientes",
          texto: "Como criar uma Segmentação de Clientes?",
        },
      ],
    },

    {
      titulo: "VARIÁVEIS SALES BOX",
      links: [
        { href: "/variaveis-salesbox" },
        { href: "/variaveis-demograficas", texto: "Variáveis demográficas" },
        { href: "/variaveis-psicograficas", texto: "Variáveis psicográficas" },
        { href: "/variaveis-financeiras", texto: "Variáveis financeiras" },
      ],
    },
  ];

  useEffect(() => {
    // Verifica se algum link corresponde à página atual
    const currentCategoryIndex = categorias.findIndex((categoria) =>
      categoria.links.some((link) => link.href === location.pathname)
    );
    if (
      currentCategoryIndex !== -1 &&
      !expandedCategory.includes(currentCategoryIndex)
    ) {
      setExpandedCategory([currentCategoryIndex]);
    }
  }, [location.pathname]);

  const handleCategoryClick = (index) => {
    // Verifica se a categoria atual está expandida
    const isExpanded = expandedCategory.includes(index);

    // Se a categoria já estiver expandida, recolhe-a imediatamente
    if (isExpanded) {
      setExpandedCategory(expandedCategory.filter((cat) => cat !== index));
    } else {
      // Adiciona a categoria ao estado para expandida
      setExpandedCategory([index]);
    }
  };

  return (
    <div>
      <h3>Outras Categorias</h3> <br />
      {categorias.map((categoria, index) => {
        const shouldDisplayCategory = !categoria.links.some(
          (link) => link.href === location.pathname
        );
        if (shouldDisplayCategory) {
          const isExpanded = expandedCategory.includes(index);
          return (
            <div key={index}>
              <h6
                className={`jas ${isExpanded ? "active" : ""}`}
                onClick={() => handleCategoryClick(index)}
              >
                <FontAwesomeIcon
                  icon={isExpanded ? faAngleDown : faAngleRight}
                  className="mr-2"
                />
                {categoria.titulo}
              </h6>
              {isExpanded && (
                <ul className="nav nav-pills flex-column">
                  {categoria.links.map((link, subIndex) => {
                    if (
                      link.href === "/variaveissalesbox" ||
                      link.href === "/data-analytics" ||
                      link.href === "/integracoes" ||
                      link.href === "/data-intelligence" ||
                      link.href === "/geomarketing" ||
                      link.href === "/personas-psicograficas" ||
                      link.href === "/smart-segmentation" ||
                      link.href === "/minha-conta-e-login"
                    ) {
                      return null;
                    }
                    return (
                      <li key={subIndex} className="nav-item">
                        <a href={link.href} className="nav-link">
                          {link.texto}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}

export default function MenuCategories() {
  return <DropdownMenu />;
}
